import React from "react"

function IconEllipsisVertical({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="ellipsis-vertical"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-ellipsis-vertical"
      {...props}
    >
      <path
        d="M12.334 15.818a2.72 2.72 0 1 1 0 5.44 2.72 2.72 0 0 1 0-5.44zm0 1.31a1.41 1.41 0 1 0-.001 2.82 1.41 1.41 0 0 0 0-2.82zm0-7.855a2.72 2.72 0 1 1 0 5.439 2.72 2.72 0 0 1 0-5.44zm0 1.309a1.41 1.41 0 1 0 0 2.822 1.411 1.411 0 0 0 0-2.822zm0-7.855a2.72 2.72 0 1 1 0 5.44 2.72 2.72 0 0 1 0-5.44zm0 1.31a1.41 1.41 0 1 0-.001 2.82 1.41 1.41 0 0 0 0-2.82z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconEllipsisVertical
